exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swipe[data-v-78fc7dad]{-webkit-filter:grayscale(1);filter:grayscale(1);position:absolute;left:0;top:25px;width:300px}@media (max-width: 320px){.swipe[data-v-78fc7dad]{width:200px;top:35px}}.guide .container[data-v-78fc7dad]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:89px;color:#000;background-color:#9c9c9c26;margin:10px 20px 0 20px}.close-guide[data-v-78fc7dad]{position:absolute;top:0;right:0}.guide-text[data-v-78fc7dad]{position:absolute;top:17px;right:0;max-width:160px;font-size:12px}\n", ""]);

// exports
